<div class="dialog">
  <img src="../../../../assets/rapido-sucess.svg" alt="success" class="success-icon" />
  <p class="title">Your request has been made</p>
  <p class="desc">You will be informed when your items arrives</p>
  <button
    class="ins-buttons button-primary flint"
    data-automation-id="get-it-success-rapido-dialog-ok-button"
    (click)="onClose()"
    translate
  >
    close
  </button>
</div>
